<template>
  <button class="Drop-Menu-Item" @click="toCallChannelsList">
    <div class="Drop-Menu-Item__svg-box">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8 4V8M8 8V12M8 8H12M8 8L4 8" stroke="var(--gray-600)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </div>
    Добавить канал
  </button>
</template>

<script setup>
  import { computed, defineProps, ref } from 'vue';
  import { useStore } from 'vuex';
  import { Props } from './scripts/props.js';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //--------------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //--------------------------------------------
  const ID = props.postId;
  //--------------------------------------------
  //Получить пост для добавления в избраннное
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[ID]);
  //Вызвать дропдаун с каналами
  const toCallChannelsList = () => {
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.channels);
    store.commit('ContentSystem/toToggleChannelMode', { is_channels_mode: true, object_id: ID });
  }
  //--------------------------------------------
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>